// extracted by mini-css-extract-plugin
export var active = "itemview-module--active--7VBAR";
export var bottompanel = "itemview-module--bottompanel--dJjBY";
export var butgroup = "itemview-module--butgroup--WtHC5";
export var button = "itemview-module--button--fYw5Q";
export var flexauto = "itemview-module--flexauto--Pvb4e";
export var flexfill = "itemview-module--flexfill--fhJZO";
export var halfwidth = "itemview-module--halfwidth--P2mrx";
export var innerslide = "itemview-module--innerslide--soYVj";
export var mainimage = "itemview-module--mainimage--gB3vq";
export var playable = "itemview-module--playable--ivXbX";
export var slidetop = "itemview-module--slidetop--UtJlL";
export var video = "itemview-module--video--9-Y5N";